import { UUID } from '../types/uuid';

export enum LiveStackStatus {
  Provisioning = 'PROVISIONING',
  Standby = 'STANDBY',
  Running = 'RUNNING',
  Starting = 'STARTING',
  Stopping = 'STOPPING',
  Destroying = 'DESTROYING',
  Unknown = 'UNKNOWN',
  Failed = 'FAILED',
}

export const LiveStackStatusTransitional = [
  LiveStackStatus.Provisioning,
  LiveStackStatus.Starting,
  LiveStackStatus.Stopping,
  LiveStackStatus.Destroying,
];
export const LiveStackStatusStable = [LiveStackStatus.Standby, LiveStackStatus.Running];
export const LiveStackStatusError = [LiveStackStatus.Failed, LiveStackStatus.Unknown];

export interface ILiveStreamUrl {
  ip: string;
  port: number;
}

export interface IDatahubUrl {
  ip: string;
  port: null;
}

export interface IRunningLiveStackDetails {
  ingress: ILiveStreamUrl;
  egress: ILiveStreamUrl;
  preview?: ILiveStreamUrl;
  datahub?: IDatahubUrl;
}

export interface ILiveStack {
  organizationUuid: UUID | null;
  userUuid: UUID | null;
  cameraId: number;
  stackName: string;
  status: LiveStackStatus;
  protocol: 'SRT';
  preview: boolean;
  capacityReservation: boolean;
  region: string;
  details: null | IRunningLiveStackDetails;
  allowListCIDR: string;
}
